module.exports = __webpack_public_path__ + "assets/bell-small-inactive-hover.f3db0329.svg";